import {
  Group,
  Radio,
  Stack,
  type RadioGroupProps,
  type RadioProps
} from "@mantine/core";
import classNames from "classnames";
import type { CommonFormFieldProps } from "../FormField";
import { FormFieldLabel } from "../FormFieldLabel";
import { FormFieldRightSection } from "../FormFieldRightSection";

interface FormFieldRadioGroupProps
  extends
    Omit<CommonFormFieldProps, "error" | "ref">,
    Omit<RadioGroupProps, "children"> {
  choices: Array<RadioProps>;
  stack?: boolean;
  type: "radio";
}

function FormFieldRadioGroup({
  choices,
  helpText,
  highlight,
  isBetaFeature,
  stack,
  type,
  warned,
  ...fieldSpecificProps
}: FormFieldRadioGroupProps) {
  const ChoiceWrapper = stack ? Stack : Group;

  return (
    <Radio.Group
      {...fieldSpecificProps}
      aria-label={
        typeof fieldSpecificProps.label === "string"
          ? fieldSpecificProps.label
          : undefined
      }
      className={classNames(
        "FormFieldRadioGroup",
        fieldSpecificProps.className
      )}
      defaultValue={undefined}
      label={
        fieldSpecificProps.label && (
          <FormFieldLabel
            helpText={helpText}
            highlight={highlight}
            isBetaFeature={isBetaFeature}
            label={fieldSpecificProps.label}
            required={fieldSpecificProps.required}
          />
        )
      }
      labelProps={{ w: "100%", ...fieldSpecificProps.labelProps }}
      value={fieldSpecificProps.value || fieldSpecificProps.defaultValue || ""}
    >
      <Group justify="space-between">
        <ChoiceWrapper>
          {choices.map((choice, index) => (
            <Radio key={index} {...choice} />
          ))}
        </ChoiceWrapper>
        <FormFieldRightSection warned={warned} />
      </Group>
    </Radio.Group>
  );
}

export { FormFieldRadioGroup, FormFieldRadioGroupProps };
